/* eslint-disable react-compiler/react-compiler */
import { graphql, useStaticQuery } from 'gatsby';
import { SanityAsset } from 'screens/Affiliate/detail/AffiliateDetail.utils';

import { SanityLanguage } from '@skippay/core/@types/cms';
import useUserCountryRelatedInfo from '@skippay/core/hooks/useUserCountryRelatedInfo';

export type PromoData = {
	i18nLang: SanityLanguage;
	title: string;
	subTitle: string;
	promoSource: string;
	promoTitle?: string;
	image: {
		asset: {
			fixed: SanityAsset['fixed'];
		};
	};
};

export type Output = {
	data: {
		nodes: PromoData[];
	};
} | null;

const usePromoData = (): Output => {
	'use no memo';

	const { sanityLanguage } = useUserCountryRelatedInfo();

	const queryResult = useStaticQuery<Output>(graphql`
		query {
			data: allSanityRegistrationPromoPage {
				nodes {
					i18nLang
					title
					subTitle
					promoTitle
					promoSource
					image {
						asset {
							... on SanityImageAsset {
								fixed(width: 890) {
									...GatsbySanityImageFixed
								}
							}
						}
					}
				}
			}
		}
	`);

	return {
		data: {
			nodes: queryResult?.data.nodes.filter((node) => node.i18nLang === sanityLanguage) || [],
		},
	};
};

export default usePromoData;
